import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";

export const postData = async (form,id, pageName) => {
    try {
        const {
            title, description, image
        } = form;

        const formData = new FormData();
        // Required Field
        if (id)
            formData.append("id", id);
        formData.append("title", title);
        formData.append("description", description);

        if (image) {
            if (typeof image === "string") {
                formData.append("image", image);
            }
            else {
                formData.append("pictures", image);
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/${pageName}/register`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getPage = async (pageNumber, pageSize, search, field, pageName) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const res = await axiosInstance.get(`/${pageName}?${params.toString()}`)
        // toast.success("Successfully fetched!");
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const getPageByID = async (id, pageName) => {

    try {
        const res = await axiosInstance.get(`/${pageName}/${id}`)
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const deletePage = async (id, pageName) => {
    try {
        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/${pageName}/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}